// api list
// dev 环境会将 value 转成 key，在添加代理
export const apiMap = {
    apiXs: 'https://xiaoshuo.wtzw.com',
    apiGw: 'https://api-gw.wtzw.com',
    apiBc: 'https://api-bc.wtzw.com',
    apiCmnt: 'https://api-cmnt.wtzw.com',
};
// 分享配置
export const shareConfig = {
    title: '新春阅读挑战火热进行中~​',
    desc: '冲地区阅读榜单，赢专属荣誉头像挂件~',
    imageUrl: 'https://cdn-front.wtzw.com/manual-upload/activity/weixin/hnyear.png',
    link: 'https://app-share.wtzw.com/h5/activity/freereaderWishBooks/sidePanel/index?full_screen=3',
};
// 分享类型列表
export const shareTypeList = ['weixin', 'friend', 'qq', 'qzone'];

export const shareTypeText = {
    weixin: '微信',
    friend: '朋友圈',
    qq: 'QQ',
    qzone: 'QQ空间',
    system: '分享到系统',
    save: '保存至相册',
    bookFriend: '书友圈',
};

export enum EActivityStatus {
    'NotStart' = '1', // 未开始
    'Start' = '2', // 进行中
    'End' = '3', // 已结束
    'EndCanLottery' = '4', // 已结束可抽奖
    'EndOnlyShow' = '5', // 已结束仅展示
}
